<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="area-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-area"></div>
                    <div class="area-view">
                        <div class="area-box">
                        <p class="now" @click="listShow = !listShow"><span>绑定大区：</span>{{ now.name }}<em class="select"></em></p>
                        <ul class="area-list" v-if="listShow">
                            <li v-for="area in areas[account_type]"
                            :key = "area.id"
                            v-bind:data-aid="area.id"
                            v-bind:data-name="area.name"
                            @click="queryPlayer" v-html="area.name"></li>
                        </ul>
                        </div>
                        <div class="player-name"><p><span>角色昵称：</span>{{ now.playerName }}</p></div>
                    </div>
                    <p class="warn"><em class="icon i-warn"></em>绑定大区后不可修改！请仔细核对参与角色。</p>
                    <div class="u-btn submit" @click="bindArea"></div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'area-modal',
    data : function (){
        return {
            listShow: false,
            now: {
                "id": 0,
                "name": "",
                "playerName": '',
            },
            areas: {
                pc: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                },{
                        "id": 23,
                        "name": "单刀赴会"
                    }],
                wg: [{
                    "id": 1,
                    "name": "火烧赤壁"
                }, {
                    "id": 2,
                    "name": "草船借箭"
                }, {
                    "id": 6,
                    "name": "荆州之战"
                }, {
                    "id": 7,
                    "name": "青梅煮酒"
                }, {
                    "id": 11,
                    "name": "九伐中原"
                }, {
                    "id": 16,
                    "name": "怀旧服"
                }, {
                    "id": 8,
                    "name": "官渡之战"
                }, {
                    "id": 9,
                    "name": "桃园结义"
                }, {
                    "id": 19,
                    "name": "火凤燎原"
                }, {
                    "id": 20,
                    "name": "卧龙出渊"
                },{
                        "id": 23,
                        "name": "单刀赴会"
                    }, {
                        "id": 17,
                        "name": "铜雀台</br>(wegame1)"
                    }, {
                        "id": 18,
                        "name": "凤仪亭</br>(wegame2)"
                    },{
                        "id": 22,
                        "name": "逍遥津</br>(wegame3)"
                    }],
                    steam: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    },{
                        "id": 23,
                        "name": "单刀赴会"
                    },{
                        "id": 21,
                        "name": "长生殿(Steam)"
                    },
                    ],                
                    test: [{
                        "id": 1,
                        "name": "火烧赤壁"
                    }, {
                        "id": 2,
                        "name": "草船借箭"
                    }, {
                        "id": 6,
                        "name": "荆州之战"
                    }, {
                        "id": 7,
                        "name": "青梅煮酒"
                    }, {
                        "id": 11,
                        "name": "九伐中原"
                    }, {
                        "id": 16,
                        "name": "怀旧服"
                    }, {
                        "id": 8,
                        "name": "官渡之战"
                    }, {
                        "id": 9,
                        "name": "桃园结义"
                    }, {
                        "id": 19,
                        "name": "火凤燎原"
                    }, {
                        "id": 20,
                        "name": "卧龙出渊"
                    }, {
                        "id": 17,
                        "name": "铜雀台</br>(wegame1)"
                    }, {
                        "id": 18,
                        "name": "凤仪亭</br>(wegame2)"
                    },{
                        "id": 21,
                        "name": "长生殿(Steam)"
                    },{
                        "id": 22,
                        "name": "逍遥津</br>(wegame3)"
                    },{
                        "id": 23,
                        "name": "单刀赴会"
                    }, {
                        "id": 100,
                        "name": "TEST_1"
                    }, {
                        "id": 110,
                        "name": "TEST_2"
                    }],                
            },
            from : {
                '1' : 'wg',
                '2' : 'steam',
                '0' : 'pc',
            },    
            visible : false,
            account_type : 'pc',
            code : '',
            cb : null,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        let fromType = this.$store.state.ua.fromType || 0;
        this.account_type = this.from[parseInt(fromType)];
        //this.account_type = 'test';
    },       
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
            localStorage.setItem("code", "");
        },
        queryPlayer(e){
            this.listShow = false;
            var _s = e.target;
            var vue = this;
                vue.now.name = _s.getAttribute('data-name').replace('</br>', '');
                vue.now.id = _s.getAttribute('data-aid');
             
            this.$axios.get(this.$global.ajax_url_map.queryplayer, {
                params: {
                    m3AreaId : parseInt(vue.now.id),
                }
            })
            .then(res => {
                vue.$toast('查询成功');
                vue.now.playerName = res.data; 
            },rej => {
                vue.$toast(rej.data);
                vue.now.playerName = '';
            })
            .catch(function (error) {
                console.log(error);
            });             

        },
        bindArea(e){
            var _s = e.target;
            var vue = this;

            //todo inviteCode
            if(!vue.now.playerName)return vue.$toast('端游未创角');
            this.$axios.post(this.$global.ajax_url_map.bind, this.$qs.stringify({
                m3AreaId : parseInt(vue.now.id),
            }))
            .then(res => {
                vue.$toast('大区绑定成功');
                this.$store.commit("$_setUserinfo", res.data);
                this.$store.commit("$_setAccount", res.userInfo);
                this.$store.commit("$_setm3b", res.data.m3b);

                vue.destroyElement();  

                vue.$goodslist_reflash();
                vue.$get_ticket_info();
                //vue.$back_index();

                if(localStorage.getItem("code")){
                    vue.$to_help(localStorage.getItem("code"));  
                }
                else{
                    vue.$back_index();
                }

                if(vue.cb && typeof cb == 'function')cb();
                              
            },rej => {
                vue.$toast(rej.message);
            })
            .catch(function (error) {
                console.log(error);
            });   
        },
    },    
}
</script>

<style scoped>
    /* area */
    .area-modal {
        width: 579px;
        height: 383px;
        background-image: url(~@/assets/images/utils/modal-bind.png);
    }

    .t-area {
        width: 293px;
        height: 51px;
        margin: 0 auto 15px;
        background-image: url(~@/assets/images/utils/title-bind.png);
    }

    .area-view .area-box {
        position: relative;
        width: 415px;
        height: 60px;
        margin: 0 auto 18px;
        box-sizing: border-box;
        color: #683d1e;
        background-image: url(~@/assets/images/utils/bg-area-item.png);
    }

    .area-box p {
        position: relative;
        padding-left: 36px;
        line-height: 60px;
    }

    .area-box .now::after {
        position: absolute;
        display: block;
        content: '';
        top: 50%;
        right: 20px;
        width: 25px;
        height: 18px;
        background-image: url(~@/assets/images/utils/bg-select.png);
        background-size: 25px 18px;
        transform: translateY(-50%);
    }

    .area-box .now span {
        padding-right: 5px;
        color: #ad7239;
    }

    .area-view .area-list {
        /* display: none; */
        position: absolute;
        top: 60px;
        left: 50%;
        width: 100%;
        padding: 0 40px 20px 40px;
        color: #d3c2b8;
        background-color: #e5be84;
        transform: translateX(-50%);
        z-index: 30;
        border: 1px solid #dbb37b;
        border-top: none;
    }

    .area-view .area-list li {
        display: inline-block;
        width: 50%;
        padding: 12px 0 10px;
        color: #683d1e;
        font-size: 24px;
        text-align: center;
        box-sizing: content-box;
        border-bottom: 1px dashed #d1a970;
    }

    .area-view .player-name {
        position: relative;
        width: 415px;
        height: 60px;
        line-height: 60px;
        margin: 0 auto;
        box-sizing: border-box;
        color: #683d1e;
        background-image: url(~@/assets/images/utils/bg-area-item.png);
    }

    .area-view .player-name span {
        display: inline-block;
        padding-left: 36px;
        padding-right: 5px;
        color: #ad7239;
    }

    .u-btn.submit {
        width: 244px;
        height: 74px;
        margin: 30px auto 0;
        background-image: url(~@/assets/images/utils/btn-submit.png);
    }

    .warn {
        display: none;
        color: #69593c;
        text-align: center;
    }  
</style>


// WEBPACK FOOTER //
// src/components/AreaBind/areaModal.vue